import AmateurProgramsLandingQuery, { AMATEUR_PROGRAMS_LANDING_QUERY } from './amateur-programs-landing.query'

export { AmateurProgramsLandingQuery, AMATEUR_PROGRAMS_LANDING_QUERY }
